<template>
    <div class="footer-box">
        <p><br>Copyright © GameJoy & Doyoyo Games Inc. All rights reserved<br>
		Doyoyo Games is an overseas brand of Gamejoy and is exclusively used on Steam platform.
		</p>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                menus:['HOME','GAMES','ABOUT US','CONTACT'],
                active: 0,
                hoverActive:'-1'
            }
        },
        created(){},
        mounted(){},
        methods:{
            // click事件
            itemClick(index){
                this.active = index;
            },
            // hover事件
            selectStyle(index){
                this.hoverActive = index;
            },
            // out事件
            showEwm(){
                this.hoverActive = '-1';
            },
        },
    }
</script>

<style scoped lang="scss">
    @import 'index';
</style>